import ReactExport from "react-export-excel";
import { Button } from "antd";
import React from "react";
import { StyledButton } from "../styled-components/Button";
import {
  TI_CENTER_BUTTON,
  TI_LIST_EXCEL_BUTTON,
  TI_MODAL_RESULT_CLOSE_BUTTON,
} from "../Constants";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExportExcelButton({
  filename,
  data,
  columns,
  tabIndex,
  ...props
}) {
  return (
    <ExcelFile
      // element={<StyledButton isActive {...props} tabIndex={tabIndex ?? TI_MODAL_RESULT_CLOSE_BUTTON - 1} />}
      element={<StyledButton isActive {...props} />}
      filename={filename}
    >
      <ExcelSheet data={data} name="Sheet 1">
        {columns.map(({ title, dataIndex }, index) => (
          <ExcelColumn label={title} value={dataIndex} key={index} />
        ))}
      </ExcelSheet>
    </ExcelFile>
  );
}
